import { AxiosError } from 'axios';
import { UseQueryOptions, useQuery } from 'react-query';
import { client } from '../util/client';
import { GetInvitationResponse } from '@aldebaran/common/types/api';

/**
 * Hook to get an invitation by slug without modifying it (readonly)
 * Contrary to useClaimInvitation, this hook does not mark the invitation as "opened"
 * and does not trigger any side effects.
 */
export const useInvitationBySlug = (
  slug: string,
  options: UseQueryOptions<GetInvitationResponse, AxiosError> = {},
) => {
  return useQuery<GetInvitationResponse, AxiosError>(
    ['invitation', 'readonly', slug],
    async () =>
      client(`/invitation/get/${slug}`).then((response) => response?.data),
    {
      enabled: !!slug,
      retry: false,
      ...options,
    },
  );
};
